import React from 'react';
import PropTypes from 'prop-types';
import { CommonModal } from 'wsm-common-modal';
import HighlightedFeatures from './HighlightedFeatures';

const HighlightedFeaturesModal = ({ features, title, isOpen, onClose }) => {
	return (
		<CommonModal
			title={title}
			isOpen={isOpen}
			onClose={onClose}
			width="responsive"
		>
			<div className="ws-hl-features">
				<HighlightedFeatures features={features} />
			</div>
		</CommonModal>
	);
};

HighlightedFeaturesModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
		.isRequired,
	features: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default HighlightedFeaturesModal;
